import React, { useEffect, useCallback } from "react"
import VideoPlayer from "./VideoPlayer.js"

function Correct({
  categoryId,
  selectedClueIndex,
  openCategoryModal,
  selectedOption,
  categories1,
  shuffledOptions,
}) {
  // Check if this option is a correct answer
  const isCorrectAnswer = (option) => {
    return categories1[selectedClueIndex].answer.includes(option)
  }

  // Check if user selected this option
  const wasSelectedByUser = (option) => {
    return selectedOption.includes(option)
  }

  const handleKeyDown = useCallback(
    (event) => {
      if (event.key === "Escape") {
        openCategoryModal()
      }
    },
    [openCategoryModal],
  )

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown)
    return () => {
      document.removeEventListener("keydown", handleKeyDown)
    }
  }, [handleKeyDown])

  return (
    <>
      <div className="categoryOverlay"></div>

      <div
        className="categoryModal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="correct-header"
      >
        <div className="closeButtonContainer">
          <button
            className="modalButton"
            onClick={openCategoryModal}
            aria-label="Close modal"
          >
            X
          </button>
        </div>
        <h1 id="correct-header" className="correctHeader">
          Correct!
        </h1>
        <div className="question">
          <p className="questionP">
            {categories1[selectedClueIndex].question
              .split("?")
              .map((line, index, array) => (
                <div key={index}>
                  <span>
                    {line.trim()}
                    {index !== array.length - 1 ? "?" : ""}
                    {index !== array.length - 1 &&
                    array[index + 1].trim() !== "" ? (
                      <>
                        <br />
                      </>
                    ) : (
                      ""
                    )}
                  </span>
                  {index !== array.length - 1 && <br />}
                </div>
              ))}
          </p>
        </div>

        <div className="category" data-testid="category">
          <form>
            {shuffledOptions.map((option, index) => (
              <div className="formContainer" key={index}>
                <input
                  className="radioButton"
                  type={
                    categories1[selectedClueIndex].answer.length > 1
                      ? "checkbox"
                      : "radio"
                  }
                  id={`option${index + 1}`}
                  name="picklist"
                  value={option}
                  checked={wasSelectedByUser(option)}
                  disabled
                  readOnly
                />
                <label className={isCorrectAnswer(option) ? "correctAnswer" : ""}>
                  {option}
                </label>
              </div>
            ))}
            <div className="explanationContainer">
              <span>Explanation:</span>
              <p className="explanation">
                {categories1[selectedClueIndex].explanation}
              </p>
            </div>
            <VideoPlayer
              videoUrl={categories1[selectedClueIndex].video_url}
              videoTitle={categories1[selectedClueIndex].video_title}
            />
          </form>
        </div>
      </div>
    </>
  )
}

export default Correct
